import { themeColors } from '../../JuvareTheme';
export const colors = {
    neutral: {
        icon: themeColors.icon.disable,
        text: themeColors.text.subtle,
    },
    red: themeColors.accent.red.bold,
    blue: themeColors.accent.blue.bold,
    green: themeColors.accent.green.bold,
    deepOrange: themeColors.accent.orange.bold,
    main: themeColors.text.main,
};
